import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { CostDocumentBufferResponse } from "@/models/api/costDocumentsOther/CostDocumentBuffer";
import { COST_DOCUMENT_TYPES } from "@/static/costDocumentTypes";

//Routes
export const URL_GET_COST_DOCUMENTS_BUFFER = "/CostDocumentOther/Buffer";
export const URL_POST_ASSIGN_COST_DOCUMENT = "/CostDocumentOther/Assign/${CostDocumentId}/${Type}";
export const URL_POST_ASSIGN_TO_BOOKING = "/CostDocumentOther/Assign/${CostDocumentId}/Booking/${ReservationNumber}";

//Requests
const _getCostDocumentsBuffer = new CancellableHelper<CostDocumentBufferResponse>(
  URL_GET_COST_DOCUMENTS_BUFFER,
  CostDocumentBufferResponse
);
_getCostDocumentsBuffer.jsonSerializer = true;
export const getCostDocumentsBuffer = async (
  genericTableRequest: GenericTableRequest
): Promise<CostDocumentBufferResponse> => {
  return await _getCostDocumentsBuffer.get(genericTableRequest);
};

const _assignCostDocument = new CancellableHelper<string>(URL_POST_ASSIGN_COST_DOCUMENT);
export const assignCostDocument = async (costDocumentId: string, type: COST_DOCUMENT_TYPES): Promise<string> => {
  return await _assignCostDocument.post({ CostDocumentId: costDocumentId, Type: type });
};

const _assignToBooking = new CancellableHelper<string>(URL_POST_ASSIGN_TO_BOOKING);
export const assignToBooking = async (costDocumentId: string, reservationNumber: string): Promise<string> => {
  return await _assignToBooking.post({ CostDocumentId: costDocumentId, ReservationNumber: reservationNumber });
};
